import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-delete-import-data-row-dialog',
  templateUrl: './delete-import-data-row-dialog.component.html',
  styleUrls: ['./delete-import-data-row-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    MatDialogModule, 
    MatButtonModule,
    MatIcon
  ]
})
export class DeleteImportDataRowDialogComponent {

  reservation_reference_id!: string;

  constructor(
    private dialogRef: MatDialogRef<DeleteImportDataRowDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.reservation_reference_id = data["Booking ID"];
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }
}